var _rect, _rect2, _rect3, _rect4, _rect5, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdminAnalytics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cot3",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#43e97b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#38f9d7"
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 14,
    fill: "#f1f5f9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 36,
    width: 8,
    height: 16,
    rx: 2,
    fill: "url(#cot3)",
    opacity: 0.85
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 28,
    width: 8,
    height: 24,
    rx: 2,
    fill: "url(#cot3)",
    opacity: 0.95
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 20,
    width: 8,
    height: 32,
    rx: 2,
    fill: "url(#cot3)",
    opacity: 0.75
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 32,
    width: 8,
    height: 20,
    rx: 2,
    fill: "url(#cot3)",
    opacity: 0.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 18l8 6 10-8 10 12 8-6",
    stroke: "url(#cot3)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminAnalytics);
export default __webpack_public_path__ + "static/media/admin-analytics.716c7a3ab11848d42e1b7992a9bda421.svg";
export { ForwardRef as ReactComponent };